import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get product categories with filters
export const getProductCategories = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/ProductCategory/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product categories:", error);
    throw error;
  }
};

// Save product category (insert or update)
export const saveProductCategory = async (productCategory) => {
  const response = await axios.post(`${BASE_URL}/api/ProductCategory/save`, productCategory, {
    headers: getAuthHeader(),
  });
  return response.data;
};

// Get active product categories for dropdown
export const getActiveProductCategories = async () => {
  try {
    const filter = { Status: true };
    const response = await axios.post(`${BASE_URL}/api/ProductCategory/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active product categories:", error);
    throw error;
  }
};
